<mat-nav-list>
  <a
      mat-list-item
      (click)="support()">
    Help
  </a>
  @if (showAppCallOut) {
    <a
      mat-list-item
      (click)="openAppCallOut()">
      {{ appCallOutTitle ? appCallOutTitle : 'Information'}}
    </a>
  }
  <a
      mat-list-item
      (click)="navigate(data.accountPath)">
    Account settings
  </a>
  @if (!data.isParentExperience) {
    @for (adminMenuItem of data.adminMenuItems; track adminMenuItem.label) {
      <a
          mat-list-item
          (click)="navigate(adminMenuItem.path)">
        Admin - {{ adminMenuItem.label }}
      </a>
    }
    @for (systemMenuItem of data.systemMenuItems; track systemMenuItem.label) {
      <a
          mat-list-item
          (click)="navigate(systemMenuItem.path)">
        System - {{ systemMenuItem.label }}
      </a>
    }
  }
  <a
      mat-list-item
      (click)="signOut()">
    Sign out
  </a>
</mat-nav-list>